<template>
    <div :class="`search-item patient ${isGrid ? 'grid' : 'bar'}`">
        <div v-if="isGrid" cols="12" class="search-item-grid-details">
            <div cols="12" class="field data-birth_date">
                <div>
                    <label for="patient-birth_date" v-text="`${t('patients::form.label.birth_date')}:`"></label>
                    <span
                        v-text="
                            searchItem.data.birth_date
                                ? moment(searchItem.data.birth_date).format($root.dateFormat)
                                : t('search::label.na')
                        "
                    ></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div cols="12" class="field data-dms_id">
                <div>
                    <label for="patient-dms_id" v-text="`${t('patients::grid.label.dms_id')}:`"></label>
                    <span v-text="searchItem.data.dms_id ? searchItem.data.dms_id : t('search::label.na')"></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div cols="12" class="field data-nhs_id">
                <div>
                    <label for="patient-nhs_id" v-text="`${t('patients::grid.label.nhs_id')}:`"></label>
                    <span v-text="searchItem.data.nhs_id ? searchItem.data.nhs_id : t('search::label.na')"></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div cols="12" class="field data-email">
                <div>
                    <label for="patient-email" v-text="`${t('patients::form.label.email')}:`"></label>
                    <span v-text="searchItem.data.email ? searchItem.data.email : t('search::label.na')"></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div cols="12" class="field data-phone">
                <div>
                    <label for="patient-phone" v-text="`${t('patients::form.label.phone')}:`"></label>
                    <span v-text="searchItem.data.phone ? searchItem.data.phone : t('search::label.na')"></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div cols="12" class="field data-consultant-name">
                <div>
                    <label for="patient-email" v-text="`${t('patients::grid.label.consultant')}:`"></label>
                    <span
                        v-text="
                            searchItem.data.consultant.name ? searchItem.data.consultant.name : t('search::label.na')
                        "
                    ></span>
                </div>
            </div>
        </div>
        <v-row v-else no-gutters>
            <v-col cols="12" class="p-0 pb-2">
                <div class="grid-status">
                    <span v-text="t(`search::types.${searchItem.type}`)"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field name">
                <span>
                    {{ searchItem.name ? searchItem.name : t('search::label.na') }}
                </span>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-birth_date">
                <div>
                    <label for="patient-birth_date" v-text="`${t('patients::form.label.birth_date')}:`"></label>
                    <span
                        v-text="
                            searchItem.data.birth_date
                                ? moment(searchItem.data.birth_date).format($root.dateFormat)
                                : t('search::label.na')
                        "
                    ></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-dms_id">
                <div>
                    <label for="patient-dms_id" v-text="`${t('patients::grid.label.dms_id')}:`"></label>
                    <span v-text="searchItem.data.dms_id ? searchItem.data.dms_id : t('search::label.na')"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-nhs_id">
                <div>
                    <label for="patient-nhs_id" v-text="`${t('patients::grid.label.nhs_id')}:`"></label>
                    <span v-text="searchItem.data.nhs_id ? searchItem.data.nhs_id : t('search::label.na')"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-email">
                <div>
                    <label for="patient-email" v-text="`${t('patients::form.label.email')}:`"></label>
                    <span v-text="searchItem.data.email ? searchItem.data.email : t('search::label.na')"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-phone">
                <div>
                    <label for="patient-phone" v-text="`${t('patients::form.label.phone')}:`"></label>
                    <span v-text="searchItem.data.phone ? searchItem.data.phone : t('search::label.na')"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-consultant-name">
                <div>
                    <label for="patient-email" v-text="`${t('patients::grid.label.consultant')}:`"></label>
                    <span
                        v-text="
                            searchItem.data.consultant.name ? searchItem.data.consultant.name : t('search::label.na')
                        "
                    ></span>
                </div>
            </v-col>
        </v-row>
        <div v-if="can('patients.get') && !isGrid" class="search-item-actions">
            <v-tooltip top transition="v-fab-transition" z-index="999999">
                <template #activator="{ on, attrs }">
                    <div
                        class="search-item-actions-button"
                        v-bind="attrs"
                        v-on="on"
                        @click="$root.goTo(previewItemUrl(item))"
                    >
                        <v-icon size="18">mdi-arrow-right</v-icon>
                    </div>
                </template>
                <span>{{ t('search::label.actions.go_to_record') }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import SearchMixin from '../../mixins/SearchMixin';
export default {
    mixins: [SearchMixin],
    methods: {
        previewItemUrl(item) {
            return route('patients.preview', { id: item.id });
        },
    },
};
</script>

<style scoped lang="scss">
.search-item {
    padding-bottom: 24px;
    border: 1px solid #eaeaea;
    border-radius: 12px;
    padding: 6px;
    padding-right: 30px;
    margin-bottom: 8px;
    position: relative;
    transition: 0.2s all ease-in-out;
    &:not(.grid) {
        &:hover,
        &:active,
        &:focus {
            background-color: #eae6f1;
            .search-item-actions {
                opacity: 1;
                visibility: visible;
            }
        }
    }
    &-actions {
        transition: 0.2s all ease-in-out;
        opacity: 0;
        visibility: hidden;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 30px;
        &-button {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #614198;
            width: 100%;
            height: 100%;
            color: #ffffff;
            border-radius: 0 12px 12px 0;
            cursor: pointer;
            .v-icon {
                color: currentColor;
            }
        }
    }

    &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 6px;
        h4 {
            margin-bottom: 0px;
        }
    }

    .field {
        padding-top: 6px;
        &:not(.single) {
            display: flex;
            flex-flow: column;
        }
        label {
        }
        span {
            font-weight: 400 !important;
            width: max-content;
            word-break: break-word;
            &.colored {
                background-color: #614198;
                color: #ffffff;
            }
            div {
                display: inherit;
            }
        }
    }

    &.grid {
        border: none;
        margin: 0;
    }

    &-grid-details {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-flow: wrap;
        flex-wrap: wrap;
        .field {
            padding: 0;
        }
        .divider {
            padding: 0 12px;
        }
    }
}
</style>
